/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_1_ResumeInputs */

const en_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 resume`)
};

const de_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Lebenslauf`)
};

const fr_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 CV`)
};

const es_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 currículum`)
};

const it_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 curriculum`)
};

const nl_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 CV`)
};

const pl_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 CV`)
};

const fi_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 ansioluettelo`)
};

const da_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 CV`)
};

const sv_pricing_feature_1_resume = /** @type {(inputs: Pricing_Feature_1_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 CV`)
};

/**
* | output |
* | --- |
* | "1 resume" |
*
* @param {Pricing_Feature_1_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_1_resume = /** @type {((inputs?: Pricing_Feature_1_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_1_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_1_resume(inputs)
	if (locale === "fr") return fr_pricing_feature_1_resume(inputs)
	if (locale === "es") return es_pricing_feature_1_resume(inputs)
	if (locale === "it") return it_pricing_feature_1_resume(inputs)
	if (locale === "nl") return nl_pricing_feature_1_resume(inputs)
	if (locale === "pl") return pl_pricing_feature_1_resume(inputs)
	if (locale === "fi") return fi_pricing_feature_1_resume(inputs)
	if (locale === "da") return da_pricing_feature_1_resume(inputs)
	if (locale === "sv") return sv_pricing_feature_1_resume(inputs)
	return en_pricing_feature_1_resume(inputs)
});